// extracted by css-extract-rspack-plugin
export default {"wrapper":"wrapper--zzLxbBIulFASJWNM","batchSize":"batch-size--ciPRLYvmFXg7q1Ia"};